import React, { useContext } from 'react'
import { EngagementLetterContext } from './EngagementLetter'
import { Stack, TextField, Typography } from '@mui/material'

const InvoiceTerms = () => {
  const { engagementLetter, setEngagementLetter } = useContext(
    EngagementLetterContext
  )

  return (
    <Stack>
      <Typography variant="title3">Invoice Terms</Typography>
      <TextField
        value={engagementLetter.invoiceTerms}
        onChange={(e) =>
          setEngagementLetter((prev) => ({
            ...prev,
            invoiceTerms: e.target.value,
          }))
        }
        minRows={2}
        multiline
      />
    </Stack>
  )
}

export default InvoiceTerms